<template>
  <div class="sp-template">
    <div class="h-title">产品价格</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="客户类型">
              <el-select v-model.lazy="conditions.customerType" clearable filterable placeholder="请输入搜索关键字" @change="selectByPage()">
                <el-option v-for="(d, i) in customerTypeList" :key="i" :label="d.name" :value="d.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户">
              <el-select v-model.lazy="conditions.orgOwner" clearable filterable placeholder="请输入搜索关键字" @change="selectByPage()">
                <el-option 
                  v-for="(customer, index) in customerArr" 
                  :key="index" 
                  :label="customer.name" 
                  :value="customer.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道">
              <el-select v-model.lazy="conditions.channelId" clearable filterable placeholder="请输入搜索关键字" @change="selectByPage()">
                <el-option 
                  v-for="(channel, index) in channelArr" 
                  :key="index" 
                  :label="channel.name" 
                  :value="channel.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(50205)" type="primary" size="small" @click="selectByPage()">搜 索</el-button>
            <el-button v-if="in_configs(50205)" size="small" @click="reset()">清 空</el-button>
          </div>
        </el-form>
        <div>
        </div>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="selectByPage">
          <el-tab-pane label="启用" name="1"></el-tab-pane>
          <el-tab-pane label="停用" name="0"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <router-link v-if="in_configs(50201)" :to="{path: '/customer/newprice'}" tag="el-button" size="small" class="padding-small">新建价格</router-link>
        </div>
      </div>
      <el-table :data="productPriceData" stripe border>
        <el-table-column label="客户类型">
          <template slot-scope="scope">
            {{customerTypeMap[scope.row.customerType]}}
          </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column prop="channelName" label="渠道"></el-table-column>
        <el-table-column prop="discount" label="折扣"></el-table-column>
        <el-table-column prop="effectiveFrom" label="起始时间">
          <template slot-scope="scope">
            {{ scope.row.effectiveFrom}}
          </template>
        </el-table-column>
        <el-table-column prop="effectiveTo" label="截至时间">
          <template slot-scope="scope">
            {{ scope.row.effectiveTo}} 
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            {{scope.row.enable ? '启用' : '停用'}}
          </template>
        </el-table-column>
        <el-table-column prop="modifyAt" label="修改时间">
          <template slot-scope="scope">
            {{ scope.row.modifyAt}} 
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="in_configs(50202)" type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button v-if="in_configs(50203)" type="text" size="mini" @click="handleLook(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background 
				@size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :current-page="currentPage" 
        :page-sizes="[5, 10, 20, 50]" 
        :page-size="pageSize" 
        layout="total, sizes, prev, pager, next, jumper" 
        :total = "parseInt(total)">
			</el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formLabelWidth: "120px",
      currentPage: 1, // 当前是第几页
      pageSize: 10, // 每页显示条目个数
      total: 0, // 总条目数
      conditions: {
        customerType: "",
        orgOwner: "",
        channelId: "",
        status: "1"
      },
      customerTypeMap: {},
      customerTypeList: [],
      productPriceData: [],
      customerArr: [],
      customerMaps:{},
      channelArr: []
    };
  },
  created() {
    setTimeout(() => {
      this.getCustomerType()
      let _this = this
      this.$axios.all([this.findAllCustomerName(), this.findAllChannle()]).then(
        this.$axios.spread(function(customerData, channelData) {
          _this.initCustomerData(customerData);
          _this.initChannelData(channelData);
          _this.query(_this.conditions.customerType, _this.conditions.orgOwner, _this.conditions.channelId, _this.conditions.status, _this.currentPage, _this.pageSize);
        })
      )
    }, 1000)
  },
  methods: {
    handleEdit(row) {
        if (row.priceDefinitions==null) {
          this.$router.push({
        path: '/customer/newprice',
        query: {
          id: row.id, 
          channelId: row.channelId, 
          channelName: row.channelName, 
          customerType: row.customerType, 
          customerName: this.customerMaps[row.orgOwner], 
          orgOwner: row.orgOwner, 
          edit: true,
           }
          }) 
        } else {
             this.$router.push({
        path: '/customer/newprice',
        query: {
          id: row.id, 
          channelId: row.channelId, 
          channelName: row.channelName, 
          customerType: row.customerType, 
          customerName: this.customerMaps[row.orgOwner], 
          orgOwner: row.orgOwner, 
          edit: true,
          newunitWeight:row.priceDefinitions.unitWeight,
          newminTotalWeight:row.priceDefinitions.minTotalWeight,
          minTotalVolume:row.priceDefinitions.minTotalVolume,
          maxWeightPerCarton:row.priceDefinitions.maxWeightPerCarton,
          minWeightPerCarton:row.priceDefinitions.minWeightPerCarton,
          minVolumePerCarton:row.priceDefinitions.minVolumePerCarton,
          billedWeightCalculationMethod:row.billedWeightCalculationMethod,
          volumeActualWeightRatio:row.priceDefinitions.volumeActualWeightRatio
        }
      })
        } 
    },
    handleLook(row) {
       if (row.priceDefinitions==null) {
          this.$router.push({
        path: '/customer/newprice',
        query: {
          id: row.id, 
          channelId: row.channelId, 
          channelName: row.channelName, 
          customerType: row.customerType, 
          customerName: this.customerMaps[row.orgOwner], 
          orgOwner: row.orgOwner, 
          look: true,
           }
          }) 
        } else {
             this.$router.push({
        path: '/customer/newprice',
        query: {
          id: row.id, 
          channelId: row.channelId, 
          channelName: row.channelName, 
          customerType: row.customerType, 
          customerName: this.customerMaps[row.orgOwner], 
          orgOwner: row.orgOwner, 
          look: true,
          newunitWeight:row.priceDefinitions.unitWeight,
          newminTotalWeight:row.priceDefinitions.minTotalWeight,
          minTotalVolume:row.priceDefinitions.minTotalVolume,
          maxWeightPerCarton:row.priceDefinitions.maxWeightPerCarton,
          minWeightPerCarton:row.priceDefinitions.minWeightPerCarton,
          minVolumePerCarton:row.priceDefinitions.minVolumePerCarton,
          billedWeightCalculationMethod:row.billedWeightCalculationMethod
        }
      })
        } 
    },
    // 获取客户类型
    getCustomerType() {
      this.$request1.get(
        '/customer/queryCustomerType'
      ).then(res => {
        if(res.data && res.data.length > 0) {
          this.customerTypeList = res.data
          this.customerTypeList.forEach(item => {
            this.customerTypeMap[item.value] = item.name
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    selectByPage() {
      this.query(this.conditions.customerType, this.conditions.orgOwner, this.conditions.channelId, this.conditions.status, this.currentPage, this.pageSize);
    },
    reset() {
      this.conditions = {
        customerType: "",
        orgOwner: "",
        channelId: "",
        status: "1"
      }
      this.selectByPage()
    },
    // 获取渠道名
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all'
      );
    },
    initChannelData(data){
      let channelData = data.data
      if(channelData && channelData.length > 0) {
        this.channelArr = channelData
      } else{
        this.$notify.error({
          title: '错误',
          message: '获取渠道列表失败！'
        });
      }
    },
    // 获取客户名
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll'
      )
    },
    initCustomerData(data) {
      if(data.data.success) {
        this.customerArr = data.data.data
        if(this.customerArr.length > 0) {
          this.customerArr.forEach(c => {
            this.customerMaps[c.id] = c.name
          })
        }
      } else{
        this.$notify.error({
          title: '错误',
          message: '获取客户列表失败！'
        });
      }
    },
    //搜索
    query(customerType, orgOwner, channelId, status, currentPage, pageSize) {
      if(customerType === '' || customerType === null) { customerType = null }
      if(orgOwner === '' || orgOwner === null) { orgOwner = null }
      if(channelId === '' || channelId === null) { channelId = null }
      if (status === '' || status === null || status === 'all'){ status = null }
      this.$request1({
        method: 'GET',
				url: '/price/customerProductPrice/query',
        params: {
          customerType: customerType,
          orgOwner: orgOwner,
          channelId: channelId,
          status: status,
          currentPage: currentPage,
          pageSize: pageSize
        }
      }).then(response => {
        if(response.data.success){
          if (response.data && response.data.data.length >= 0) {
            this.productPriceData = response.data.data;
            this.total = response.data.total;
          }
        }else{
          this.$message.error(response.data.message)
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      // this.query(null, null, null, null, this.currentPage, val);
      this.query(this.conditions.customerType, this.conditions.orgOwner, this.conditions.channelId, this.conditions.status, this.currentPage, val);
    },
    handleCurrentChange(val) {
      // this.query(null, null, null, null, val, this.pageSize);
      this.query(this.conditions.customerType, this.conditions.orgOwner, this.conditions.channelId, this.conditions.status, val, this.pageSize);
    }
  }
};
</script>

<style lang="scss" scoped>
.padding-small{
  padding: 9px 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/customer/productprice.vue